import { SiteHomePageRoute } from '@townsquare/router/route-types';
import { followProjectActionRoute } from '@townsquare/routes/follow-project-action';

import { FollowProjectAction } from './loadable';
import { followProjectResource } from './resource';

followProjectActionRoute.component = FollowProjectAction;
followProjectActionRoute.resources = [followProjectResource];
export const followProjectActionRouterRoute: SiteHomePageRoute = followProjectActionRoute;
